import { createFileRoute } from '@tanstack/react-router';

import CheckoutReturn from '@/components/_checkout/CheckoutReturn.tsx';
import { CardLayout } from '@/components/layouts/index.tsx';

const PaymentPage = () => <CheckoutReturn action="cancel" />;

export const Route = createFileRoute('/checkout/cancel')({
  component: () => (
    <CardLayout title="shared.navigation.checkout">
      <PaymentPage />
    </CardLayout>
  ),
});
